/** Walk offsetParent chain until we hit a builder root (same idea as DnD hit-testing). */
const MAX_OFFSET_PARENT_HOPS = 8;

export function resolveColumnReorderLayoutParent(
  start: HTMLElement | null
): HTMLElement | null {
  let cur: HTMLElement | null = start;
  for (let i = 0; i < MAX_OFFSET_PARENT_HOPS && cur; i++) {
    if (cur.classList.contains("builder-component")) {
      return cur;
    }
    cur = cur.offsetParent as HTMLElement | null;
  }
  return null;
}

/**
 * True when `el` is the layout host for sibling column reorder (row, inner-section,
 * footer marker class, or header/footer roots).
 */
export function isColumnReorderLayoutParent(el: HTMLElement | null): boolean {
  if (!el?.classList.contains("builder-component")) {
    return false;
  }
  const type = el.getAttribute("data-component-type");
  if (type === "header" || type === "footer") {
    return true;
  }
  return (
    el.classList.contains("row") ||
    el.classList.contains("inner-section") ||
    el.classList.contains("builder-footer")
  );
}
